"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSchema = void 0;
// TODO: Move all this to the shared lib whenever it's available.
const zod_1 = require("zod");
exports.BaseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    deletedAt: zod_1.z.date().optional(),
    isDeleted: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=base-schema.js.map